module.exports = __webpack_public_path__ + "static/media/done.833a7c94.svg";